import { FlexLandingPageBanner } from './FlexLandingPageBanner';
import { FlexLandingPageContainer } from './FlexLandingPageContainer';
import { FlexLandingPageCoverage } from './FlexLandingPageCoverage';
import { FlexLandingPageFAQ } from './FlexLandingPageFAQ';
import { FlexLandingPageGuide } from './FlexLandingPageGuide';
import { FlexLandingPageHero } from './FlexLandingPageHero';
import { FlexLandingPageLogo } from './FlexLandingPageLogo';

export const FlexLandingPage = {
  Container: FlexLandingPageContainer,
  Logo: FlexLandingPageLogo,
  Hero: FlexLandingPageHero,
  Guide: FlexLandingPageGuide,
  Banner: FlexLandingPageBanner,
  Coverage: FlexLandingPageCoverage,
  FAQ: FlexLandingPageFAQ,
};
